var _defs, _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReportsicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bf14f9ca11"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 49.167969 34.011719 L 325.917969 34.011719 L 325.917969 340.761719 L 49.167969 340.761719 Z M 49.167969 34.011719 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bf14f9ca11)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 285.242188 319.296875 L 274.328125 316.5625 L 274.328125 70.277344 C 274.328125 67.464844 272.03125 65.167969 269.21875 65.167969 L 106.691406 65.167969 L 110.023438 45.175781 L 314.628906 64.648438 Z M 264.113281 330.769531 L 59.804688 330.769531 L 59.804688 75.382812 L 264.113281 75.382812 Z M 106.253906 34.542969 C 103.539062 34.222656 101.164062 36.160156 100.746094 38.792969 L 96.335938 65.167969 L 54.695312 65.167969 C 51.882812 65.167969 49.589844 67.464844 49.589844 70.277344 L 49.589844 335.875 C 49.589844 338.691406 51.882812 340.984375 54.695312 340.984375 L 269.21875 340.984375 C 272.03125 340.984375 274.328125 338.691406 274.328125 335.875 L 274.328125 327.097656 L 288.414062 330.609375 C 288.832031 330.710938 289.230469 330.769531 289.652344 330.769531 C 290.6875 330.769531 291.707031 330.449219 292.5625 329.871094 C 293.761719 329.011719 294.558594 327.695312 294.71875 326.238281 L 325.363281 60.640625 C 325.523438 59.28125 325.125 57.925781 324.265625 56.847656 C 323.410156 55.769531 322.152344 55.113281 320.777344 54.972656 L 106.253906 34.542969 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 80.234375 116.246094 L 70.019531 116.246094 L 70.019531 197.96875 L 253.898438 197.96875 L 253.898438 187.753906 L 80.234375 187.753906 L 80.234375 116.246094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 192.984375 146.09375 L 161.300781 125.003906 L 131.3125 154.992188 L 115.988281 139.667969 L 86.839844 168.820312 L 94.0625 176.042969 L 115.988281 154.113281 L 131.3125 169.4375 L 162.617188 138.132812 L 192.226562 157.90625 L 256.191406 125.921875 L 251.601562 116.785156 L 192.984375 146.09375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 80.234375 106.03125 C 85.863281 106.03125 90.449219 101.441406 90.449219 95.816406 C 90.449219 90.1875 85.863281 85.597656 80.234375 85.597656 C 74.609375 85.597656 70.019531 90.1875 70.019531 95.816406 C 70.019531 101.441406 74.609375 106.03125 80.234375 106.03125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 243.679688 106.03125 C 249.308594 106.03125 253.898438 101.441406 253.898438 95.816406 C 253.898438 90.1875 249.308594 85.597656 243.679688 85.597656 C 238.054688 85.597656 233.464844 90.1875 233.464844 95.816406 C 233.464844 101.441406 238.054688 106.03125 243.679688 106.03125 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 80.234375 300.121094 C 74.609375 300.121094 70.019531 304.710938 70.019531 310.339844 C 70.019531 315.964844 74.609375 320.554688 80.234375 320.554688 C 85.863281 320.554688 90.449219 315.964844 90.449219 310.339844 C 90.449219 304.710938 85.863281 300.121094 80.234375 300.121094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 243.679688 300.121094 C 238.054688 300.121094 233.464844 304.710938 233.464844 310.339844 C 233.464844 315.964844 238.054688 320.554688 243.679688 320.554688 C 249.308594 320.554688 253.898438 315.964844 253.898438 310.339844 C 253.898438 304.710938 249.308594 300.121094 243.679688 300.121094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 70.019531 218.398438 L 131.3125 218.398438 L 131.3125 208.183594 L 70.019531 208.183594 L 70.019531 218.398438 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 161.957031 320.554688 L 223.25 320.554688 L 223.25 310.339844 L 161.957031 310.339844 L 161.957031 320.554688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 70.019531 238.832031 L 131.3125 238.832031 L 131.3125 228.613281 L 70.019531 228.613281 L 70.019531 238.832031 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 70.019531 259.261719 L 131.3125 259.261719 L 131.3125 249.046875 L 70.019531 249.046875 L 70.019531 259.261719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 80.234375 269.476562 L 70.019531 269.476562 L 70.019531 279.691406 L 80.234375 279.691406 L 80.234375 269.476562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 90.449219 279.691406 L 100.664062 279.691406 L 100.664062 269.476562 L 90.449219 269.476562 L 90.449219 279.691406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 121.097656 269.476562 L 110.882812 269.476562 L 110.882812 279.691406 L 121.097656 279.691406 L 121.097656 269.476562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 151.742188 254.152344 C 151.742188 236.175781 165.089844 221.253906 182.390625 218.757812 L 182.390625 259.261719 L 222.890625 259.261719 C 220.398438 276.558594 205.472656 289.90625 187.496094 289.90625 C 167.785156 289.90625 151.742188 273.867188 151.742188 254.152344 Z M 233.464844 254.152344 L 233.464844 249.046875 L 192.605469 249.046875 L 192.605469 208.183594 L 187.496094 208.183594 C 162.136719 208.183594 141.527344 228.792969 141.527344 254.152344 C 141.527344 279.511719 162.136719 300.121094 187.496094 300.121094 C 212.855469 300.121094 233.464844 279.511719 233.464844 254.152344 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 198.070312 236.933594 L 207.570312 240.726562 L 216.488281 218.398438 L 253.898438 218.398438 L 253.898438 208.183594 L 209.582031 208.183594 L 198.070312 236.933594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 141.527344 320.554688 L 151.742188 320.554688 L 151.742188 310.339844 L 141.527344 310.339844 L 141.527344 320.554688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 121.097656 320.554688 L 131.3125 320.554688 L 131.3125 310.339844 L 121.097656 310.339844 L 121.097656 320.554688 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportsicon);
export default __webpack_public_path__ + "static/media/reportsicon.7f267ce16aafd865d236b43187f6953e.svg";
export { ForwardRef as ReactComponent };